var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('el-header',[_c('topbar')],1),_c('div',{staticClass:"page-body"},[_c('sidebar'),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"moveInUp"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }